const auxi = ( props ) => props.children;

export default auxi;


// WEBPACK FOOTER //
// ./src/hoc/Auxi/Auxi.js